import ImageRepository from './ImageRepository';
import VideoRepository from './VideoRepository';

//Create All the scene textures and add to texture cache to use whenever required
function CreateTexturesFromScenes(scenes, startIndex, endIndex, loadedTextures) {
  startIndex = startIndex ? startIndex : 0;
  endIndex = endIndex ? (scenes.length < endIndex ? scenes.length : endIndex) : scenes.length;
  for (let i = startIndex; i < endIndex; i++) {
    var scene = scenes[i];
    if (scene) {
      CreateUpdateTextures(scene, loadedTextures);
    }
  }
}

//Create or update a scene textures and add to texture cache to use whenever required
function CreateUpdateTextures(scene, loadedTextures) {
  scene.background.src.forEach(src => {
    if (src) {
      if (src.type === 'image') {
        if (src.url && src.url !== '') {
          ImageRepository.Load(src);
          if (src.blurUrl && src.blurUrl !== '' && src.mode === 'fit') {
            let blurSrc = {...src, url:src.blurUrl, asset_id: src.asset_id ? src.asset_id+"_blur": null}
            ImageRepository.Load(blurSrc);
          }
        }
      } else if (src.type === 'video') {
        if (src.url && src.url !== '') {
          VideoRepository.Load(src, loadedTextures);
        }
      }
    }
  });
  for (let i = 0; i < scene.sub_scenes.length; i++) {
    let subScene = scene.sub_scenes[i];
    if (subScene.displayItems && subScene.displayItems.length > 0) {
      for (let j = 0; j < subScene.displayItems.length; j++) {
        let dispItem = subScene.displayItems[j];
        if (dispItem.type === 'visual') {
          if (dispItem.visualType === 'video') {
            VideoRepository.Load({ url: dispItem.src, resource_id: dispItem.id }, loadedTextures);
          } else {
            ImageRepository.Load(dispItem.src, true, dispItem.id);
          }
        }
      }
    }
  }
  if (scene.background.logo && scene.background.logo.src && scene.background.logo.src !== '') {
    ImageRepository.Load(scene.background.logo.src);
  }
}

function CheckIfTextureValid(src) {
  if (src.type === 'image') {
    return ImageRepository.CheckIfImageTextureValid(src);
  } else if (src.type === 'video') {
    return VideoRepository.CheckIfVideoTextureValid(src);
  }
}
function GetTexture(src, type) {
  if (src.type === 'image') {
    return ImageRepository.GetTexture(src);
  } else if (src.type === 'video') {
    return VideoRepository.GetTexture(src);
  }
}
function RemoveTexture(src) {
  if (src.type === 'image') {
    return ImageRepository.RemoveTexture(src);
  } else if (src.type === 'video') {
    return VideoRepository.RemoveTexture(src);
  }
}
function GetImageTexture(src) {
  return ImageRepository.GetTexture(src);
}
function GetTextureScale(texture, CanvasWidth, CanvasHeight, mode) {
  if (mode === 'fit') {
    return Math.min(CanvasWidth / texture.width, CanvasHeight / texture.height);
  } else if (mode === 'crop') {
    return Math.max(CanvasWidth / texture.width, CanvasHeight / texture.height);
  } else {
    return Math.min(CanvasWidth / texture.width, CanvasHeight / texture.height);
  }
}
export default {
  CreateTexturesFromScenes,
  CreateUpdateTextures,
  CheckIfTextureValid,
  GetTexture,
  GetTextureScale,
  GetImageTexture,
  RemoveTexture,
};
